import { Site, SiteContext } from './../../api';
import { freezeDeep } from './../js/js.utils';

/* Copyright IBM Corp. 2017 */
const _DEFAULT_SITE = 'default';

const _EMPTY_SITE: Site = freezeDeep({
    pages: [],
    id: null
});

const _EMPTY_SITE_CONTEXT: SiteContext = freezeDeep({
    parent: undefined,
    sibling: [],
    breadcrumb: [],
    children: [],
    site: _EMPTY_SITE
});

const _UNDEFINED_SITE_CONTEXT: SiteContext = freezeDeep({
    parent: undefined,
    sibling: [],
    breadcrumb: [],
    children: [],
    site: undefined
});

export {
    _DEFAULT_SITE as DEFAULT_SITE,
    _EMPTY_SITE as EMPTY_SITE,
    _EMPTY_SITE_CONTEXT as EMPTY_SITE_CONTEXT,
    _UNDEFINED_SITE_CONTEXT as UNDEFINED_SITE_CONTEXT
};
